import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import BounceLoader from "react-spinners/ClipLoader";
import useQueryParams from "../utils/query.params";
import { ERROR_ROUTE, SCREENER_ROUTE, START_ROUTE } from "../constants/routes.constants";
import RespondentFlowApi from "../services/respondentFlow.api";
import Error from "./Error";
import LoaderComponent from "../components/LoaderComponent";
import SurveyStatusPage from "../components/question-components/survey-status";
import FormSkeleton from "../components/question-components/form-skeleton";
import LoggerService from "../services/logger.service";
import { LOG_EVENTS } from "../constants/logs.constants";
import { SessionUtils } from "../utils/session.utils";
import { useRespondentContext } from "../contexts/respondent.context";

const Landing = () => {
  const [Loader] = useState(true);
  const [ErrorMessage, setErrorMessage] = useState("Loading");
  const [paramActive, setParamActive] = useState(false);
  const { journeyToken } = useRespondentContext();
  let params = {};
  useQueryParams().forEach((value, key) => {
    params[key] = value;
  });
  useEffect(() => {
    if (params) {
      if (paramActive === false) setParamActive(true);
    }
    // eslint-disable-next-line
  }, [params]);

  let navigate = useNavigate();

  useEffect(() => {
    if (paramActive === true) {
      try {
        params["url"] = window.location.href;
        LoggerService.logEvent(LOG_EVENTS.ENDING_RECEIVED);
        RespondentFlowApi.post("/v1/ending", params)
          .then(async (data) => {
            if (data.result === "not_ok") {
              LoggerService.logEvent(LOG_EVENTS.ENDING_ERROR, "Ending returned not_ok");
              navigate(`${ERROR_ROUTE}?token=${params.token}`);
              return;
            } else if (data.hasError) {
              LoggerService.logEvent(LOG_EVENTS.ENDING_ERROR, data.messages?.[0]);
              setErrorMessage(data.messages[0]);
              return;
            } else {
              if (data.isInternalRedirect) {
                let obj = {};
                obj.traceId = data.traceId;
                obj.paramList = data.paramList;
                obj.sessionUid = data.sessionUid;
                obj.surveyUid = data.surveyUid;
                obj.vendorUid = data.vendorUid;
                obj.vendorToken = data.vendorToken ?? "";
                obj.token = data.token;
                obj.tokenId = data.tokenId;
                obj.userUid = data.userUid;
                obj.userId = data.userId;
                obj.isEnding = true;

                await LoggerService.logEvent(LOG_EVENTS.ENDING_REDIRECT_TO_START);

                // sessionStorage.clear() wipes the journey/respondent tokens too -
                // the journey continues (re-routing), it isn't ending here, so
                // restore them rather than letting a fresh one get minted.
                sessionStorage.clear();
                SessionUtils.setJourneyToken(journeyToken);
                if (obj.token) SessionUtils.setRespondentToken(obj.token);
                sessionStorage.setItem("params", JSON.stringify(obj));

                navigate(`${START_ROUTE}?token=${obj.token}`);
              } else {
                await LoggerService.logEvent(LOG_EVENTS.ENDING_REDIRECT_TO_SUPPLIER);
                await LoggerService.logEvent(LOG_EVENTS.JOURNEY_END, "Redirected to supplier from ending");
                sessionStorage.clear();
                window.location.href = `${data.redirectUrl}`;
              }
            }
          })
          .catch((e) => {
            console.error(e);
            LoggerService.logEvent(LOG_EVENTS.ENDING_ERROR, "Error calling ending: " + (e?.message || String(e)));
            navigate(ERROR_ROUTE);
          });
      } catch (err) {
        console.error(err);
        LoggerService.logEvent(LOG_EVENTS.ENDING_ERROR, "Exception in ending: " + (err?.message || String(err)));
        throw err;
      }
    }
    // eslint-disable-next-line
  }, [paramActive]);

  return (
    <>
      {/* {Loader ? (
        ErrorMessage === "Loading" ? (
          <FormSkeleton />
        ) : (
          <SurveyStatusPage status="ending" />
        )
      ) : (
        <SurveyStatusPage status="ending" />
      )} */}
      <FormSkeleton />
    </>
  );
};

export default Landing;
